import { GoACallout } from "@abgov/react-components";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface INotificationProps {
  messageType: string;
  messageHeader: string;
  messageBody?: string;
}

const Notification: React.FC<INotificationProps> = (props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (props.messageBody) {
        await navigator.clipboard.writeText(props.messageBody);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
      }
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <div style={{ marginTop: "25px", float: "right" }}>
      <GoACallout
        type={
          props.messageType === "success"
            ? "success"
            : props.messageType === "error"
            ? "emergency"
            : "information"
        }
      >
        <p>{props.messageHeader}</p>
        {props.messageBody && (
          <>
            {/* <TextField
              value={props.messageBody}
              InputProps={{ readOnly: true }}
              sx={{ width: "500px" , fieldset: { border: "none" }, marginLeft: '-12px', overflowWrap: 'anywhere', wordWrap: 'break-word', overflow: 'hidden'}} 
            /> */}
            {props.messageBody}
            <Tooltip title={copied ? "Copied!" : "Copy"}>
              <IconButton onClick={handleCopy} color={copied ? "success" : "primary"}>
                {copied ? <CheckIcon /> : <ContentCopyIcon />}
              </IconButton>
            </Tooltip>
          </>
        )}
      </GoACallout>
    </div>
  );
};

export default Notification;
